import React from 'react';

interface HealthReportFiltersProps {
  childId: string;
}

export const HealthReportFilters: React.FC<HealthReportFiltersProps> = ({ childId }) => {
  return (
    <div className="text-warm-gray">
      <p>No reports generated yet.</p>
    </div>
  );
};

export default HealthReportFilters;
